/**
 * @flow
 * @relayHash e73f54478f7635e430745a22146f2b08
 */

/* eslint-disable */

"use strict";

/*::
import type { ConcreteRequest } from 'relay-runtime';
type UserList_viewer$ref = any;
export type UserFilter = {
  AND?: ?$ReadOnlyArray<UserFilter>,
  OR?: ?$ReadOnlyArray<UserFilter>,
  active?: ?boolean,
  active_not?: ?boolean,
  createdAt?: ?any,
  createdAt_not?: ?any,
  createdAt_in?: ?$ReadOnlyArray<any>,
  createdAt_not_in?: ?$ReadOnlyArray<any>,
  createdAt_lt?: ?any,
  createdAt_lte?: ?any,
  createdAt_gt?: ?any,
  createdAt_gte?: ?any,
  email?: ?string,
  email_not?: ?string,
  email_in?: ?$ReadOnlyArray<string>,
  email_not_in?: ?$ReadOnlyArray<string>,
  email_lt?: ?string,
  email_lte?: ?string,
  email_gt?: ?string,
  email_gte?: ?string,
  email_contains?: ?string,
  email_not_contains?: ?string,
  email_starts_with?: ?string,
  email_not_starts_with?: ?string,
  email_ends_with?: ?string,
  email_not_ends_with?: ?string,
  id?: ?string,
  id_not?: ?string,
  id_in?: ?$ReadOnlyArray<string>,
  id_not_in?: ?$ReadOnlyArray<string>,
  id_lt?: ?string,
  id_lte?: ?string,
  id_gt?: ?string,
  id_gte?: ?string,
  id_contains?: ?string,
  id_not_contains?: ?string,
  id_starts_with?: ?string,
  id_not_starts_with?: ?string,
  id_ends_with?: ?string,
  id_not_ends_with?: ?string,
  name?: ?string,
  name_not?: ?string,
  name_in?: ?$ReadOnlyArray<string>,
  name_not_in?: ?$ReadOnlyArray<string>,
  name_lt?: ?string,
  name_lte?: ?string,
  name_gt?: ?string,
  name_gte?: ?string,
  name_contains?: ?string,
  name_not_contains?: ?string,
  name_starts_with?: ?string,
  name_not_starts_with?: ?string,
  name_ends_with?: ?string,
  name_not_ends_with?: ?string,
  updatedAt?: ?any,
  updatedAt_not?: ?any,
  updatedAt_in?: ?$ReadOnlyArray<any>,
  updatedAt_not_in?: ?$ReadOnlyArray<any>,
  updatedAt_lt?: ?any,
  updatedAt_lte?: ?any,
  updatedAt_gt?: ?any,
  updatedAt_gte?: ?any,
};
export type AppQueryVariables = {|
  filter?: ?UserFilter
|};
export type AppQueryResponse = {|
  +viewer: {|
    +id: string,
    +$fragmentRefs: UserList_viewer$ref,
  |}
|};
*/

/*
query AppQuery(
  $filter: UserFilter
) {
  viewer {
    ...UserList_viewer_Vt7Yj
    id
  }
}

fragment UserList_viewer_Vt7Yj on Viewer {
  allUsers(first: 10, filter: $filter) {
    pageInfo {
      hasNextPage
      endCursor
    }
    edges {
      node {
        ...User_user
        id
        __typename
      }
      cursor
    }
  }
  id
}

fragment User_user on User {
  id
  name
  email
  active
}
*/

const node /*: ConcreteRequest*/ = (function() {
  var v0 = [
      {
        kind: "LocalArgument",
        name: "filter",
        type: "UserFilter",
        defaultValue: null
      }
    ],
    v1 = {
      kind: "ScalarField",
      alias: null,
      name: "id",
      args: null,
      storageKey: null
    };
  return {
    kind: "Request",
    operationKind: "query",
    name: "AppQuery",
    id: null,
    text:
      "query AppQuery(\n  $filter: UserFilter\n) {\n  viewer {\n    ...UserList_viewer_Vt7Yj\n    id\n  }\n}\n\nfragment UserList_viewer_Vt7Yj on Viewer {\n  allUsers(first: 10, filter: $filter) {\n    pageInfo {\n      hasNextPage\n      endCursor\n    }\n    edges {\n      node {\n        ...User_user\n        id\n        __typename\n      }\n      cursor\n    }\n  }\n  id\n}\n\nfragment User_user on User {\n  id\n  name\n  email\n  active\n}\n",
    metadata: {},
    fragment: {
      kind: "Fragment",
      name: "AppQuery",
      type: "Query",
      metadata: null,
      argumentDefinitions: v0,
      selections: [
        {
          kind: "LinkedField",
          alias: null,
          name: "viewer",
          storageKey: null,
          args: null,
          concreteType: "Viewer",
          plural: false,
          selections: [
            {
              kind: "FragmentSpread",
              name: "UserList_viewer",
              args: [
                {
                  kind: "Variable",
                  name: "filter",
                  variableName: "filter",
                  type: null
                }
              ]
            },
            v1
          ]
        }
      ]
    },
    operation: {
      kind: "Operation",
      name: "AppQuery",
      argumentDefinitions: v0,
      selections: [
        {
          kind: "LinkedField",
          alias: null,
          name: "viewer",
          storageKey: null,
          args: null,
          concreteType: "Viewer",
          plural: false,
          selections: [
            {
              kind: "LinkedField",
              alias: null,
              name: "allUsers",
              storageKey: null,
              args: [
                {
                  kind: "Variable",
                  name: "filter",
                  variableName: "filter",
                  type: "UserFilter"
                },
                {
                  kind: "Literal",
                  name: "first",
                  value: 10,
                  type: "Int"
                }
              ],
              concreteType: "UserConnection",
              plural: false,
              selections: [
                {
                  kind: "LinkedField",
                  alias: null,
                  name: "pageInfo",
                  storageKey: null,
                  args: null,
                  concreteType: "PageInfo",
                  plural: false,
                  selections: [
                    {
                      kind: "ScalarField",
                      alias: null,
                      name: "hasNextPage",
                      args: null,
                      storageKey: null
                    },
                    {
                      kind: "ScalarField",
                      alias: null,
                      name: "endCursor",
                      args: null,
                      storageKey: null
                    }
                  ]
                },
                {
                  kind: "LinkedField",
                  alias: null,
                  name: "edges",
                  storageKey: null,
                  args: null,
                  concreteType: "UserEdge",
                  plural: true,
                  selections: [
                    {
                      kind: "LinkedField",
                      alias: null,
                      name: "node",
                      storageKey: null,
                      args: null,
                      concreteType: "User",
                      plural: false,
                      selections: [
                        v1,
                        {
                          kind: "ScalarField",
                          alias: null,
                          name: "name",
                          args: null,
                          storageKey: null
                        },
                        {
                          kind: "ScalarField",
                          alias: null,
                          name: "email",
                          args: null,
                          storageKey: null
                        },
                        {
                          kind: "ScalarField",
                          alias: null,
                          name: "active",
                          args: null,
                          storageKey: null
                        },
                        {
                          kind: "ScalarField",
                          alias: null,
                          name: "__typename",
                          args: null,
                          storageKey: null
                        }
                      ]
                    },
                    {
                      kind: "ScalarField",
                      alias: null,
                      name: "cursor",
                      args: null,
                      storageKey: null
                    }
                  ]
                }
              ]
            },
            {
              kind: "LinkedHandle",
              alias: null,
              name: "allUsers",
              args: [
                {
                  kind: "Variable",
                  name: "filter",
                  variableName: "filter",
                  type: "UserFilter"
                },
                {
                  kind: "Literal",
                  name: "first",
                  value: 10,
                  type: "Int"
                }
              ],
              handle: "connection",
              key: "UserList_allUsers",
              filters: ["active"]
            },
            v1
          ]
        }
      ]
    }
  };
})();
// prettier-ignore
(node/*: any*/).hash = 'da0e349fe0f755a61f0e010e2c1c9bfa';
module.exports = node;



// WEBPACK FOOTER //
// ./src/__generated__/AppQuery.graphql.js